module.exports = __webpack_public_path__ + "img/banner1.d08687af.jpg";